import { Permission } from "~/enums/permission";

export default async function () {
  const { tokenScopes } = await useOAuth();

  const isGrantedForPermission = async (permission: Permission): Promise<boolean> => {
    if (!Object.values<string>(Permission).includes(permission)) {
      throw new Error(`Invalid permission "${permission}"`);
    }

    const scopes = await tokenScopes();

    return scopes.includes(permission);
  };

  return {
    isGrantedForPermission,
  };
}
